var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"account-edit-modal",attrs:{"showCloseBtn":true,"fullScreen":true},on:{"close":_vm.close}},[_c('AccountEdit',{attrs:{"isNested":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }